import builder from '../builder';
import Bin from '../../streamline-icons/bold/bin.svg';

export default builder('IconBinBold', Bin);
